/*!
 * @license
 * Copyright 2019 Alfresco, Inc. and/or its affiliates.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *       http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/// <reference path="./lib/process-editor/bpmn.d.ts" />
/// <reference path="./lib/process-editor/diagram.d.ts" />

export * from './lib/api/public-api';
export * from './lib/code-editor/public-api';
export * from './lib/components/input-mapping-table/public-api';
export * from './lib/components/output-mapping-table/public-api';
export * from './lib/components/mapping-dialog/public-api';
export * from './lib/process-editor/public-api';
export * from './lib/connector-editor/public-api';
export * from './lib/confirmation-dialog/public-api';
export * from './lib/connector-editor/public-api';
export * from './lib/extension/public-api';
export * from './lib/helpers/public-api';
export * from './lib/i18n/public-api';
export * from './lib/interfaces/public-api';
export * from './lib/process-editor/public-api';
export * from './lib/services/public-api';
export * from './lib/store/public-api';
export * from './lib/validators/public-api';
export * from './lib/variables/public-api';
export * from './lib/workbench-layout/public-api';
export * from './lib/project-editor/public-api';

export * from './lib/api-implementations/acm-api/acm-api.module';

// TODO: Remove it ===================================================
export * from './lib/api-implementations/acm-api/content-types';
export * from './lib/api-implementations/acm-api/form-definition';
// TODO: =============================================================
